import store from '../store/store';
import getUserLanguageName from './getUserLanguageName';
import getLanguageNameFromTag from './getLanguageNameFromTag';

export default function getTargetLanguageName(): string {
    return store.settings.targetLanguage
        ? getLanguageNameFromTag(store.settings.targetLanguage)
        : getUserLanguageName();
}
